module.exports = __webpack_public_path__ + "percent_4.df195729ec0be3dd3da0534dcd1651b8.svg";